import { ReactElement } from 'react';

import { LinkProps, Link as StyledLink } from '@beeline/lk-utils';

import { ServiceType } from ':types';

const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
interface LinkPropsExpand extends Omit<LinkProps, 'openInNewTab' | 'to'> {
  serviceType?: ServiceType;
  to: string;
}

// FIXME: should use ServiceType ('internal' | 'external')
export function Link({ serviceType, ...props }: LinkPropsExpand): ReactElement {
  const isExternalLink = ABSOLUTE_URL_REGEX.test(props.to);
  const isExternalNavigation = serviceType === 'external' || isExternalLink;

  return (
    <StyledLink
      {...props}
      navigationType={isExternalNavigation ? 'default' : 'inner'}
      openInNewTab={isExternalNavigation}
    />
  );
}
